import React from 'react';
import { styleOptions } from '../styleOptions';

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

const DimensionsStep = ({ width, height, quantity, onWidthChange, onHeightChange, onQuantityChange, dontKnowMeasurements, onDontKnowMeasurementsChange, errors, product, style }) => {
  // Get the product image based on selected product and style
  const getProductImage = () => {
    console.log('DimensionsStep - Product:', product, 'Style:', style);

    if (product) {
      const productStyles = styleOptions[product];


      if (productStyles && productStyles.length > 0) {
        // First, try to find the exact style match
        if (style) {
          const selectedStyle = productStyles.find(s => s.id === style);


          if (selectedStyle && selectedStyle.image) {

            return selectedStyle.image;
          }
        }

        // If no exact match, use the first available style image for this product
        const firstStyle = productStyles[0];
        if (firstStyle && firstStyle.image) {

          return firstStyle.image;
        }
      }
    }


    // Fallback to placeholder
    return 'https://placehold.co/600x516?text=Product+Dimensions';
  };

  const productImage = getProductImage();
  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Enter Dimensions
      </h2>

      {/* Two Column Layout */}
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 md:grid-cols-2">
        {/* Left Column - Image */}
        <div className="relative h-[516px] overflow-hidden rounded-lg">
          <img
            src={productImage}
            alt="Product Dimensions"
            className="h-full w-full object-cover"
          />
        </div>

        {/* Right Column - Form */}
        <div className="flex flex-col justify-center rounded-lg bg-gray-100 p-12">
          <h3 className="mb-6 text-center text-[24px] font-bold text-black">
            Enter Your Dimensions
          </h3>

          {/* Don't Know Measurements Checkbox */}
          <div className="mb-6">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={dontKnowMeasurements}
                onChange={(e) => onDontKnowMeasurementsChange(e.target.checked)}
                className="mr-3 h-5 w-5 cursor-pointer accent-[#ED6B64]"
              />
              <span className="text-[15px] text-[#4c4c4c]">
                Not sure
              </span>
            </label>
          </div>

          {/* Width Input */}
          <div className="mb-4">
            <label className="mb-2 block text-[15px] text-[#4c4c4c]">
              Width (metres){!dontKnowMeasurements && '*'}
            </label>
            <input
              type="number"
              step="0.1"
              min="0"
              value={width}
              onChange={(e) => onWidthChange(e.target.value)}
              placeholder="e.g., 4.5"
              disabled={dontKnowMeasurements}
              className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] focus:border-[#ED6B64] focus:outline-none disabled:bg-gray-200 disabled:cursor-not-allowed"
            />
            {errors?.width && (
              <p className="mt-2 text-sm text-red-500">{errors.width}</p>
            )}
          </div>

          {/* Projection Input */}
          <div className="mb-6">
            <label className="mb-2 block text-[15px] text-[#4c4c4c]">
              Projection (metres){!dontKnowMeasurements && '*'}
            </label>
            <input
              type="number"
              step="0.1"
              min="0"
              value={height}
              onChange={(e) => onHeightChange(e.target.value)}
              placeholder="e.g., 3.0"
              disabled={dontKnowMeasurements}
              className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] focus:border-[#ED6B64] focus:outline-none disabled:bg-gray-200 disabled:cursor-not-allowed"
            />
            {errors?.height && (
              <p className="mt-2 text-sm text-red-500">{errors.height}</p>
            )}
          </div>

          {/* Only show quantity field if not verandas-pergolas */}
          {product !== 'verandas-pergolas' && (
            <div className="mb-4">
              <label className="mb-2 block text-[15px] text-[#4c4c4c]">
                Quantity
              </label>
              <input
                type="number"
                step="1"
                min="1"
                value={quantity}
                onChange={(e) => onQuantityChange(e.target.value)}
                placeholder="e.g., 1"
                className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] focus:border-[#ED6B64] focus:outline-none"
              />
              {errors?.quantity && (
                <p className="mt-2 text-sm text-red-500">{errors.quantity}</p>
              )}
            </div>
          )}

          <p className="mx-auto text-center text-xs text-[#4c4c4c]">
            These dimensions are approximate and can be adjusted later
          </p>
        </div>
      </div>
    </div>
  );
};

export default DimensionsStep;
